import { t } from "i18next";
import moment from "moment-timezone";
import { confirmAlert } from "react-confirm-alert";
import { Trans } from "react-i18next";

export const getLocalDate = (value, timezone) => {
  let newDate = new Date(value);
  return moment.tz(newDate, timezone).format(t("date_formats.shortDate"));
};

export let defaultAlertMessages = {
  TittleError: <Trans>{t("error")}</Trans>,
  TittleWarning: <Trans>{t("warning")}</Trans>,
  TittleSuccess: <Trans>{t("success")}</Trans>,
  MessageDetailError: <Trans>{t("please_try_again")}</Trans>,
  MessageDetailWarning: <Trans>{t("sure_continue")}</Trans>,
  MessageDetailSuccess: <Trans>{t("successfully_completed")}</Trans>,
  Ok: <Trans>{t("ok")}</Trans>,
  Yes: <Trans>{t("yes")}</Trans>,
  No: <Trans>{t("no")}</Trans>,
};

export const serviceMessageSuccess = (message) => {
  if (message && typeof message === "string") {
    message = message.match(/^['"].*['"]$/)
      ? message.replace(/^['"](.*)['"]$/, "$1")
      : message;
  }
  defaultAlertMessages.MessageDetailSuccess = t(message);
  confirmAlert({
    customUI: ({ onClose }) => {
      return getConfirmSuccessMessage(onClose, defaultAlertMessages);
    },
  });
};

export const serviceMessageError = (message) => {
  if (message && typeof message === "string") {
    message = message.match(/^['"].*['"]$/)
      ? message.replace(/^['"](.*)['"]$/, "$1")
      : message;
  }
  defaultAlertMessages.MessageDetailError = t(message);
  confirmAlert({
    customUI: ({ onClose }) => {
      return getConfirmErrorMessage(onClose, defaultAlertMessages);
    },
  });
};

export const getConfirmErrorMessage = (onClose, objMessageInfo) => {
  let messageDetail = objMessageInfo?.MessageDetailError || "";

  if (messageDetail && typeof messageDetail === "string") {
    messageDetail = messageDetail.match(/^['"].*['"]$/)
      ? t(messageDetail.replace(/^['"](.*)['"]$/, "$1"))
      : t(messageDetail);
  }

  return (
    <div className="eConfirm">
      <div className="circle-wrapper">
        <div className="error circle"></div>
        <div className="error-icon icon">
          <i className="fa fa-times"></i>
        </div>
      </div>
      <h2 className="text-center">{objMessageInfo.TittleError}</h2>
      <hr></hr>
      <p>{messageDetail}</p>
      <div className="eConfirmButtons text-center">
        <button className="k-button btn-primary w-50" onClick={onClose}>
          {objMessageInfo.Ok}
        </button>
      </div>
    </div>
  );
};

export const getConfirmSuccessMessage = (onClose, objMessageInfo) => {
  let messageDetail = objMessageInfo?.MessageDetailSuccess || "";

  if (messageDetail && typeof messageDetail === "string") {
    messageDetail = messageDetail.match(/^['"].*['"]$/)
      ? t(messageDetail.replace(/^['"](.*)['"]$/, "$1"))
      : t(messageDetail);
  }

  return (
    <div className="eConfirm">
      <div className="circle-wrapper">
        <div className="success circle"></div>
        <div className="success-icon  icon">
          <i className="fa fa-check"></i>
        </div>
      </div>
      <h2 className="text-center">{objMessageInfo.TittleSuccess}</h2>
      <hr></hr>
      <p>{messageDetail}</p>
      <div className="eConfirmButtons text-center">
        <button className="k-button btn-success w-50" onClick={onClose}>
          {objMessageInfo.Ok}
        </button>
      </div>
    </div>
  );
};

export const getConfirmWarningMessage = (
  onClose,
  handleYesClick,
  objMessageInfo,
  objData
) => {
  return (
    <div className="eConfirm">
      <div className="circle-wrapper">
        <div className="warning circle"></div>
        <div className="warning-icon icon">
          <i className="fa fa-exclamation"></i>
        </div>
      </div>
      <h2 className="text-center">{objMessageInfo.TittleWarning}</h2>
      <hr></hr>
      <p>{objMessageInfo.MessageDetailWarning}</p>
      <div className="eConfirmButtons text-center">
        <button
          className="k-button btn-primary w-50"
          onClick={() => {
            handleYesClick(objData);
            onClose();
          }}
        >
          {objMessageInfo.Yes}
        </button>
        <button className="k-button btn-danger w-50" onClick={onClose}>
          {objMessageInfo.No}
        </button>
      </div>
    </div>
  );
};
